import React from 'react';
import TextField from '../../textfield';
import BaseDialog from './base';
import { nameFromPath } from '../util';
import { bindEvent } from '../../../../util';

const RenameDialog = React.memo(
	({ fieldActionRequest, onClose, validateFieldPath, ...props }) => {
		const [fieldName, setFieldName] = React.useState();
		const [validation, setFieldNameValidation] = React.useState({});

		const handleClose = (confirm) => onClose && onClose(confirm && {fieldName});

		const handleFieldNameChange = fieldName => {
			setFieldNameValidation(validateFieldPath(fieldName));
			setFieldName(fieldName);
		}

		return (
			<BaseDialog 
				{...props} 
				onClose={handleClose}
				title="Rename Field:"
				confirmBtnTxt="Rename" 
				disableConfirm={validation.passed !== true} 
				>
					<TextField 
						autoFocus={true} 
						defaultValue={nameFromPath(fieldActionRequest.path)}
						onChange={bindEvent(handleFieldNameChange)}
						{...validation.passed === false && { error: true, helperText: validation.msg }}
						/>
			</BaseDialog>
		);
	}
);

export default RenameDialog;